import React from "react";

export default function FractionDemoData({
  formData,
  updateFormData,
  errors,
  clearFieldError,
  disabled,
  tokens,
}) {

  const handleChange = (e) => {
    const { name, value } = e.target;
    clearFieldError(name);
    if (name === "bulkExpressionFile" || name === "token") {
      const [id, fileName] = value.split("|"); // Split the concatenated value
      updateFormData({ [name]: { id, value: fileName } });
    }
    else {
      updateFormData({ [name]: value });
    }
  };

  return (
    <>
      <div
        className="row ps-3 ps-lg-4 pe-3 pe-lg-4 pb-1"
        style={{ paddingTop: "24px" }}
      >
        <div className="col-xl-3 col-lg-4 mb-3">
          <p className="form-label">
            Select Demo Data
          </p>
          <span className="review-text sub-text">
            Explore with our pre-configured demo data to familiarize yourself
            with iSort functionality.
          </span>
        </div>

        <div className="col-xl-6 col-lg-8">
          <div className="form-group">
            <label className="menu-options label-spacing">
              Bulk Expression File*
            </label>

            <select
              name="bulkExpressionFile"
              value={
                `${formData.bulkExpressionFile.id}`
                  ? `${formData.bulkExpressionFile.id}|${formData.bulkExpressionFile.value}`
                  : ""
              }
              onChange={handleChange}
              className="form-select"
              required
              disabled={disabled}
            >
              <option value="" disabled>
                Select...
              </option>
              <option value={"1|Demo data file for Fractions"}>
                Demo Data file for Fractions (5 samples)
              </option>
            </select>
            {errors.bulkExpressionFile && (
              <p className="error-text">{errors.bulkExpressionFile}</p>
            )}
          </div>

          <div className="form-group">
            <label className="menu-options label-spacing">
              Token*
            </label>
            <select
              name="token"
              value={
                `${formData.token.id}`
                  ? `${formData.token.id}|${formData.token.value}`
                  : ""
              }
              onChange={handleChange}
              className="form-select"
              required
              disabled={disabled}
            >
              <option value="" disabled>
                Select...
              </option>
              {tokens.length > 0 ? (
                tokens.map((token) => (
                  <option key={token.id} value={`${token.id}|${token.token}`}>
                    {token.token} ({token.type})
                  </option>
                ))
              ) : (
                <option disabled>No valid tokens available for your organisation.</option>
              )}
            </select>
          </div>
          {errors.token && <p className="error-text">{errors.token}</p>}
        </div>
        <hr
          style={{
            borderTop: "1px solid #EEEEEE",
            opacity: "1",
            marginTop: "6px",
          }}
        />
        <div className="col-xl-3 col-lg-4 mb-3">
          <span className="review-text sub-text">
            Name this run (optional) to find your results easily later (up to 25 characters).
          </span>
        </div>
        <div className="col-xl-6 col-lg-8">
          <div className="form-group">
            <label className="menu-options label-spacing">
              Run Name
            </label>
            <input
              type="text"
              name="runName"
              value={formData.runName}
              onChange={handleChange}
              placeholder="e.g. My Demo Run"
              maxLength={25}
              disabled={disabled}
            />
          </div>
        </div>
      </div>
    </>
  );
}
